module.exports = __webpack_public_path__ + "img/hq.8338618.svg";